import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=b3ddc2ac&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3ddc2ac')) {
      api.createRecord('b3ddc2ac', component.options)
    } else {
      api.reload('b3ddc2ac', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=b3ddc2ac&", function () {
      api.rerender('b3ddc2ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-40IcAaI6eSUNO/JS/pricehelp.vue"
export default component.exports